/** Facet filters for ads campaign Algolia tables (status is faceted on AD_CAMPAIGNS). */
export const EXCLUDE_DRAFT_FACET_FILTERS: (string | string[])[] = [
  ["status:-DRAFT"],
];

export const DRAFT_ONLY_FACET_FILTERS: (string | string[])[] = [["status:DRAFT"]];

export const DRAFT_CAMPAIGNS_HITS_PER_PAGE = 4;

export function draftCampaignPaginationRange({
  page,
  pageSize,
  total,
}: {
  page: number;
  pageSize: number;
  total: number;
}): { start: number; end: number } {
  if (total <= 0) {
    return { start: 0, end: 0 };
  }
  const zeroBasedStart = (page - 1) * pageSize;
  return {
    start: zeroBasedStart + 1,
    end: Math.min(zeroBasedStart + pageSize, total),
  };
}
